// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1PqjO","text":"SelectPayment_text__13qdR","title":"SelectPayment_title__2zozF","btn":"SelectPayment_btn__22A9m"};